import { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import PawPrint from '../components/PawPrint';
import api from '../lib/api';
import { toast } from 'sonner';

const ResetPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) { toast.error('Invalid reset link'); return; }
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { reset_token: token, new_password: newPassword });
      toast.success('Password reset successful!');
      navigate('/login');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Reset failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#1B4332]" data-testid="reset-password-page">
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#BFDB38]/5 rounded-full -translate-y-1/2 translate-x-1/2"></div>
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-[#FF6B6B]/5 rounded-full translate-y-1/2 -translate-x-1/2"></div>

      <div className="w-full max-w-md relative z-10">
        <div className="flex items-center justify-center gap-2 mb-8">
          <PawPrint className="w-10 h-10" color="#BFDB38" />
          <span className="text-3xl font-black text-white" style={{ fontFamily: 'Nunito, sans-serif' }}>PurrCheck</span>
        </div>

        <div className="bg-white border-2 border-[#1B4332]/10 rounded-3xl p-8 shadow-2xl" data-testid="reset-password-card">
          <h2 className="text-2xl font-black text-[#1B4332] text-center mb-6" style={{ fontFamily: 'Nunito, sans-serif' }}>
            Reset Password
          </h2>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <Label htmlFor="password" className="text-[10px] uppercase tracking-[0.15em] font-bold text-[#FF6B6B]">New Password</Label>
              <Input
                id="password"
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="bg-white border-2 border-[#1B4332]/10 rounded-xl focus:border-[#1B4332] h-12"
                required
                minLength={6}
                data-testid="reset-password-input"
              />
            </div>

            <Button
              type="submit"
              className="w-full rounded-full font-bold h-12 bg-[#1B4332] hover:bg-[#1B4332]/90 text-white text-base hover:-translate-y-0.5 transition-all"
              disabled={loading}
              data-testid="reset-submit-btn"
            >
              {loading ? 'Resetting...' : 'Reset Password'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
